<template>
  <card class="card-stats" :show-footer-line="true">
    <slot>
      <div class="subtitle">
        <span
          class="font-weight-bold mb-0 subtitle--highlight"
          :style="`color:${backgroundColor}`"
          >{{ subTitle }}</span
        >
      </div>
    </slot>

    <div v-if="$slots.legend || legend">
      <slot name="legend">
        <div
          class="text-white legend"
          :style="`background-color:${legendBackgroundColor};`"
        >
          <span>{{ legend }}</span>
        </div>
      </slot>
    </div>

    <p class="mt-1 mb-0 text-sm">
      <slot name="footer">
        <div :style="`background-color:${backgroundColor}`">
          <p class="text-white h5 font-weight-bold mb-0 title">
            {{ title ? title.toUpperCase() : "" }}
          </p>
        </div>
      </slot>
    </p>
  </card>
</template>
<script>
import Card from "./Card.vue";

export default {
  name: "stats-card-custom",
  components: {
    Card
  },
  props: {
    title: String,
    subTitle: Number, // no. of tasks
    subTitleSuffix: Number, // total tasks
    backgroundColor: String,
    legendBackgroundColor: String,
    legend: String // percentage
  }
};
</script>
<style lang="scss" scoped>
.legend {
  padding: 0.25rem 1rem;
  border-top-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
  position: absolute;
  top: 0;
  right: 0;
}
.title {
  text-align: center;
  padding: 0.75rem 0.5rem;
}
.subtitle {
  text-align: center;
  &--highlight {
    font-size: 40px;
  }
}
</style>
